<script>
import NeonHeistGame from "@/components/neon-heist-preview/NeonHeistGame.vue";

export default {
  name: "NeonHeistPreview",
  components: {
    NeonHeistGame
  }
};
</script>

<template>
  <NeonHeistGame />
</template>
